import permissions from './permissions'

export default permissions
